import { render, staticRenderFns } from "./Remove2FA.vue?vue&type=template&id=1c5f0fe7&"
import script from "./Remove2FA.vue?vue&type=script&lang=js&"
export * from "./Remove2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports